import React from 'react';
import {Form, Formik} from 'formik';
import {
  matchRoutes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import FormikSelect from 'components/formikFields/select';
import CustomButton from 'components/customButton';
import {QualitiesOptions, wantedUnit} from './utilities';
import FormikInputGroup from 'components/formikFields/inputGroup';
import {PurchaseInfoSchema} from './helper/schema';
import {usePurchase} from 'context/purchaseContext';

const PurchaseInfo = () => {
  const navigate = useNavigate();
  const {purchaseId} = useParams();
  const {stepTwoInfo, purchaseValue} = usePurchase();
  const location = useLocation();
  const isFarm = matchRoutes(
    [{path: '/farm/add-ad/purchase/info/:purchaseId'}],
    location,
  );

  return (
    <div className="w-full h-full flex px-4 my-4">
      <Formik
        validationSchema={PurchaseInfoSchema}
        initialValues={{
          quality: purchaseValue ? purchaseValue?.quality : undefined,
          wanted_unit: purchaseValue ? purchaseValue?.wanted_unit : 'ton',
          wanted: purchaseValue ? purchaseValue?.wanted : undefined,
        }}
        onSubmit={values => {
          stepTwoInfo({
            wanted_unit: values.wanted_unit,
            quality: values.quality,
            wanted: values.wanted,
          });
          navigate(
            `/${
              isFarm ? 'farm' : 'wholesaler'
            }/add-ad/purchase/registration/${purchaseId}`,
            {
              state: {
                wanted_unit: values.wanted_unit,
                quality: values.quality,
                wanted: values.wanted,
                title: location?.state?.title,
              },
            },
          );
        }}
      >
        {() => (
          <Form className="flex flex-col w-full h-full py-4 gap-4 ">
            <div className="flex flex-col w-full h-full py-4 gap-6">
              <FormikSelect
                name="quality"
                label="کیفیت"
                required
                Options={QualitiesOptions}
              />
              <FormikInputGroup
                name="wanted"
                required
                label="مقدار مورد نیاز"
                Options={wantedUnit}
                optionName="wanted_unit"
              />
              <CustomButton
                type="submit"
                title="ادامه"
                className="!bg-primary"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PurchaseInfo;
